import React from 'react';
import TicketPanorama from './TicketPanorama';
import { CreateTicketOptions } from '../../../../interfaces/api/Ticket';
import useTicket from '../../../../hooks/api/useTicket';
import { withRouter } from 'react-router';

const TicketPanoramaContainer = ({ history, ...props }) => {
  const { create: createTicket } = useTicket();

  const handleCreateTicket = async (allTicketOptions: CreateTicketOptions) => {
    const {
      newContactPhoneNumber,
      newContactEmail,
      newContactLastname,
      newContactFirstname,
      ...ticketOptions
    } = allTicketOptions;

    const ticket = await createTicket(ticketOptions);

    history?.push(`/dashboard/tickets/${ticket.id}`);
  };

  return <TicketPanorama onCreateTicket={handleCreateTicket} {...props} />;
};

export default withRouter(TicketPanoramaContainer);
